import '@hapana/shared/utils/type-defs.util'

/** @type{Styles} */
export const styles = {
  outlined: {
    borderStyle: 'solid',
    borderColor: 'gray.8',
    borderRadius: {
      xs: 0,
      sm: 0,
    },
    borderTopWidth: {
      xs: 0,
      sm: 1,
    },
    borderBottomWidth: {
      xs: 0,
      sm: 0,
    },
    borderLeftWidth: {
      xs: 0,
      sm: 0,
    },
    borderRightWidth: {
      xs: 0,
      sm: 0,
    },
  },
  wrapper: {
    padding: 2,
    paddingRight: 2.5,
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
  },
  warningWrapper: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    display: 'flex',
  },
  iconHolder: {
    backgroundColor: 'error.main',
    borderRadius: 40,
    width: 24,
    height: 24,
    marginRight: 1.2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconHolderOutstanding: {
    backgroundColor: 'warning.main',
    borderRadius: 40,
    width: 24,
    height: 24,
    marginRight: 1.2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  exclamationIcon: {
    color: 'white !important',
    fontSize: 16,
    '.MuiSvgIcon-root': {
      fontSize: 32,
      color: 'gray.0',
    },
  },
  accordionIconHolder: {
    marginTop: 0.3,
    '.MuiSvgIcon-root': {
      backgroundColor: 'error.main',
      borderRadius: 48,
      width: 24,
      height: 24,
      marginRight: 1.2,
    },
  },
  accordionIconHolderOutstanding: {
    marginTop: 0.3,
    '.MuiSvgIcon-root': {
      backgroundColor: 'warning.main',
      borderRadius: 40,
      paddingLeft: 0.5,
      paddingTop: 0.5,
      width: 24,
      height: 24,
      marginRight: 1.2,
    },
  },
  multiplePaymentItemWrapper: {
    display: 'flex',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: 'gray.8',
    justifyContent: 'space-between',
    paddingY: 2,
    paddingX: 0,
    '&:last-of-type': {
      borderBottomWidth: 0,
    },
    '&:first-child': {
      paddingTop: 1,
    },
    width: 'inherit',
    alignItems: 'center',
  },
  multiplePaymentItem: {
    flexDirection: 'column',
    display: 'flex',
  },
  retryButtonWrapper: {
    justifyContent: 'end',
    alignItems: 'center',
  },
  linkButton: {
    textAlign: 'center',
    '&.MuiButton-root': {
      paddingX: 1.5,
    },
  },

  accordionSummary: {
    borderBottom: 'none',
    marginRight: 3,
    marginLeft: 2,
    '.MuiAccordionSummary-content': {
      marginY: 2,
      alignItems: 'center',
    },
  },
  accordionContent: { paddingTop: 0, paddingBottom: 1, paddingX: 3 },
  divider: {
    borderColor: 'gray.8',
  },
  buttonWrapper: {
    textAlign: 'right',
  },
}
